import { unifiedEnvConfig } from "../constants/api-endpoint";
import { httpPost } from "../utility/requestHelper";

export const fetchTicketList = async (tObj) => {
  return await httpPost(`${unifiedEnvConfig.TICKET_LIST}`, tObj)
      .then(async(res) => {
        const {
          data: { status, data, pagination },
        } = res || {};
        if (status === 200 && data) {
          return {data:data,pagination:pagination}
        } else {
          return {}
        }
      })
};

export const fetchTicketCount = async (tObj) => {
  return await httpPost(`${unifiedEnvConfig.TICKET_COUNT}`, tObj)
      .then(async(res) => {
        const {
          data: { status, data },
        } = res || {};
        if (status === 200 && data) {
          return data
        } else {
          return {}
        }
      })
};

export const sendTicketReply = async (tObj) => {
  return await httpPost(`${unifiedEnvConfig.REPLY_TICKET}`, tObj,{ "Content-Type": "multipart/form-data"})
      .then(async(res) => {
        const {
          data: { status },
        } = res || {};
        if (status === 201) {
          return true
        } else {
          return false
        }
      })
};

export const sendTicketStatusUpdate = async (tObj) => {
  return await httpPost(`${unifiedEnvConfig.TICKET_STATUS_UPDATE}`, tObj)
      .then(async(res) => {
        const {
          data: { status },
        } = res || {};
        if (status === 200) {
          return true
        } else {
          return false
        }
      })
};